import { render, staticRenderFns } from "./DevToolsPage.vue?vue&type=template&id=2bca654a&scoped=true&"
import script from "./DevToolsPage.vue?vue&type=script&lang=ts&"
export * from "./DevToolsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bca654a",
  null
  
)

export default component.exports